module.exports = __webpack_public_path__ + "img/star-hover.a6cf652e.svg";